import type { SvgIconProps } from "@mui/material";
import { SvgIcon } from "@mui/material";

const VideoFileIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
    <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" fill="#EDE7F6" stroke="#D1C4E9" />
    <path
      d="M16.8594 11.3495C17.3602 11.6387 17.3602 12.3615 16.8594 12.6506L9.29316 17.019C8.79236 17.3081 8.16635 16.9467 8.16635 16.3684L8.16635 7.63172C8.16635 7.05344 8.79235 6.69202 9.29316 6.98116L16.8594 11.3495Z"
      fill="#9575CD"
    />
  </SvgIcon>
);

export default VideoFileIcon;
